export const apis = {
    //Login and register
    LOGIN: 'api/userlogin',
    GET_CURRENT_LOGGED_IN_USER: 'api/get_current_logged_user',
    REGISTER: 'api/userRegister',
    FORGOT_PASSWORD: 'api/forgot-password',
    RESET_PASSWORD: 'api/reset-password',
    LOGOUT: 'api/userlogout',

};